import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IActionMenuItem {
  // Action identifier emitted when the item is clicked.
  action: string;
  // Translation key shown as the item label.
  label: string;
  // Boxicons class name without the "bx " prefix, e.g. "bx-pencil".
  icon?: string;
  // Bootstrap text color suffix, e.g. "primary" | "danger".
  color?: string;
  disabled?: boolean;
  hidden?: boolean;
}

/**
 * Reusable "more actions" dropdown. Collapses a row of icon buttons into a single menu so
 * tables stay readable as the number of per-row actions grows.
 */
@Component({
  selector: 'app-action-menu',
  templateUrl: './action-menu.component.html',
})
export class ActionMenuComponent {
  @Input() items: IActionMenuItem[] = [];
  @Input() label = 'buttons.more';
  @Input() icon = 'bx-dots-vertical-rounded';
  @Output() itemClick = new EventEmitter<string>();

  get visibleItems(): IActionMenuItem[] {
    return (this.items || []).filter((item) => !item.hidden);
  }

  onItemClick(item: IActionMenuItem) {
    if (item.disabled) {
      return;
    }
    this.itemClick.emit(item.action);
  }
}
